import DeliverabilityRate from '@admin/tokens/deliverability_rate'
import Panel from '@admin/components/panel'
import moment from 'moment'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Sent)',
  collection: {
    endpoint: '/api/admin/truevail/admin/deliverability/processings',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Day)', key: 'processed_at', primary: true, format: (record) => (
        <div className="token">
          { moment(record.processed_at).tz(context.admin.account.timezone).format('YYYY-MM-DD') }
        </div>
      ) },
      { label: 't(Sent)', key: 'sent_count', collapsing: true, align: 'right' },
      { label: 't(Open)', key: 'open_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="open_rate" />
      ) },
      { label: 't(Click)', key: 'click_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="click_rate" />
      ) },
      { label: 't(Bounce)', key: 'bounce_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="bounce_rate" />
      ) },
      { label: 't(Soft Bounce)', key: 'soft_bounce_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="soft_bounce_rate" />
      ) },
      { label: 't(Hard Bounce)', key: 'hard_bounce_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="hard_bounce_rate" />
      ) },
      { label: 't(Complain)', key: 'complain_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="complain_rate" />
      ) },
      { label: 't(Unsubscribe)', key: 'unsubscribe_rate', collapsing: true, align: 'right', format: (domain) => (
        <DeliverabilityRate domain={ domain } metric="unsubscribe_rate" />
      ) }
    ],
    defaultQuery: { 
      interval: 'day',
      domain_segment_id: props.domain_segment.id
    },
    defaultSort: { key: 'processed_at', order: 'desc' },
    empty: {
      svg: 'mail',
      title: 't(No Emails)',
      text: 't(There are no sent emails for this domain segment)'
    },
    entity: 'day',
    onClick: (record) => context.router.push(`/admin/truevail/admin/sent/domain_segments/${props.domain_segment.id}/day/${moment(record.processed_at).tz(context.admin.account.timezone).format('YYYY-MM-DD')}`)
  }
})

export default Panel(null, mapPropsToPanel)
